import { Mail } from "lucide-react";
import { Link, useSearchParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md border-white/60 bg-white/90 shadow-[0_24px_80px_rgba(13,19,20,0.08)] backdrop-blur">
        <CardHeader className="space-y-4 text-center">
          <div className="bg-accent/10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <Mail className="text-accent h-8 w-8" />
          </div>
          <p className="text-muted text-xs font-medium tracking-[0.35em] uppercase">
            Verification required
          </p>
          <CardTitle className="font-heading text-primary text-4xl leading-none font-normal tracking-[-0.04em]">
            Check your inbox
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted mb-6">
            We&apos;ve sent a verification link to{" "}
            {email ? (
              <span className="text-foreground font-medium">{email}</span>
            ) : (
              "your email address"
            )}
            . Please confirm access before signing in to the BOI connector workspace.
          </p>
          <p className="text-muted mb-6 text-sm">
            Didn&apos;t receive the email? Check spam, then request a fresh invite if needed.
          </p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">Back to sign in</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
